import type { Area } from "./types.js";
import { sensojiLocations } from "./locations-sensoji.js";
import { sumidaParkLocations } from "./locations-sumida.js";
import { westAsakusaLocations } from "./locations-west.js";

const MAPBOX_TOKEN =
  "pk.eyJ1Ijoia2ltb25vcmVudGFsYW5uIiwiYSI6ImNtbnY1OXNtNjE1MWYycW9kaGR2M3U3M3oifQ.nYIKKqgPz3yGB0urAVDxkA";
const MAPBOX_STYLE = "kimonorentalann/cmnv7kieh007401re7rxn9q7r";

const mapboxStatic = (lng: number, lat: number, zoom: number) =>
  `https://api.mapbox.com/styles/v1/${MAPBOX_STYLE}/static/${lng},${lat},${zoom},0/1280x1280@2x?access_token=${MAPBOX_TOKEN}`;

export const areas: Area[] = [
  {
    id: "west-asakusa",
    name: "West Asakusa",
    nameJa: "西浅草",
    mapImage: mapboxStatic(139.795, 35.715, 17.28),
    kvKey: "west-asakusa-pins",
    fallbackLocations: westAsakusaLocations,
  },
  {
    id: "sensoji",
    name: "Asakusa",
    nameJa: "浅草寺",
    mapImage: "https://www.senso-ji.jp/images_en/visit_ill01.jpg",
    kvKey: "asakusa-map-pins",
    fallbackLocations: sensojiLocations,
  },
  {
    id: "sumida-park",
    name: "Sumida Park",
    nameJa: "隅田公園",
    mapImage: mapboxStatic(139.802, 35.713, 17),
    kvKey: "sumida-park-pins",
    fallbackLocations: sumidaParkLocations,
  },
];

/** Default area shown on first load (Sensoji is the iconic illustration map) */
export const DEFAULT_AREA_INDEX = 1;
